import { useState, useEffect } from "react";
import styled from "@emotion/styled";
import {
	Switch,
	Select,
	Button,
	MenuItem,
	IconButton,
	ToggleButtonGroup,
	ToggleButton,
	ThemeProvider,
	TextField, Typography, Badge, Chip,
} from "@mui/material";
import {
	AttachmentRounded,
	CloseRounded,
	DeleteRounded,
} from "@mui/icons-material";
import "./index.scss";
import toggleTheme from "../../../../components/toggleTheme";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import KVPair from "../../../../components/kv_pair";

function ValueModal(props) {
	dayjs.locale("ru");
	const [student, setStudent] = useState(null);
	const [lesson, setLesson] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const originalStudent = { ...props.student };
	const [disabled, setDisabled] = useState(false);
	const [techMap, setTechMap] = useState(null);
	const isAdmin = localStorage.getItem("roles").split(",").find((r) => r === "AttNewAdmin") !== undefined;

	useEffect(() => {
		setStudent(copyObject(props.student ?? {}));
		setLesson(copyObject(props.day ?? {}))
		console.log('student', student);
		console.log('lesson', lesson);
		setDisabled(!props?.student?.medicalCommissionPassed && props.disabled);
		setTechMap(copyObject(props.techMap ?? {}));
	}, [props.student, props.day, props.medicalGroupCheckEnabled, props.techMap]);

	function copyObject(obj) {
		return JSON.parse(JSON.stringify(obj));
	}

	const StyledSwitch = styled(Switch)(() => ({
		"& .MuiSwitch-switchBase": {
			"&.Mui-checked": {
				color: "#fff",
				"& + .MuiSwitch-track": {
					backgroundColor: "#00BFA5",
					opacity: 1,
				},
			},
		},
		"& .MuiSwitch-track": {
			backgroundColor: "#FF1744",
			opacity: 1,
			"&::before, &::after": {
				content: '""',
				position: "absolute",
				top: "50%",
				transform: "translateY(-50%)",
				width: 16,
				height: 16,
				backgroundSize: "contain",
			},
		},
		"& .MuiSwitch-thumb": {
			backgroundColor: "#D9D9D9",
		},
	}));

	const addEmptyButton = () => {
		if (lesson === null || lesson === undefined)
			return <></>;
		
		if (student) {
			const vals = lesson.grades;
			if (!vals?.length) {
				return <Button onClick={addValue}>Добавить оценку</Button>;
			}
		}

		return <></>;
	};

	const closeModal = () => {
		props.closeHandler(originalStudent);
	};

	const setPresenceState = (e, checked) => {
		lesson.attended = checked;
		applyVisualChanges();
	};

	function regularGradeToDisciplineRequirementGradeV2(regularGrade, disciplineRequirement) {
		if (!disciplineRequirement)
			return 0;

		switch (regularGrade) {
			case 2:
				return disciplineRequirement.conversionGrade2 ?? 0;
			case 3:
				return disciplineRequirement.conversionGrade3 ?? 0;
			case 4:
				return disciplineRequirement.conversionGrade4 ?? 0;
			case 5:
				return disciplineRequirement.conversionGrade5 ?? 0;
			default:
				return 0;
		}
	}
	
	function regularGradeToDisciplineRequirementGrade(regularGrade, disciplineRequirement, useV2 = true) {
		// legacy
		
		if (useV2) // redirect to new version of the function
			return regularGradeToDisciplineRequirementGradeV2(regularGrade, disciplineRequirement);
		
		if (!disciplineRequirement)
			return 0;
		
		const points = disciplineRequirement.points;
		
		// Абсолютно непонятно: зачем в старом алгоритме баллы умножались на уже поделенные по оценкам баллы... 
		// В итоге при оценке 5 получалось возведение в квадрат
		switch (regularGrade) {
			case 2:
				return points * disciplineRequirement.conversionGrade2 ?? 0;
			case 3:
				return points * disciplineRequirement.conversionGrade3 ?? 0;
			case 4:
				return points * disciplineRequirement.conversionGrade4 ?? 0;
			case 5:
				return points * disciplineRequirement.conversionGrade5 ?? 0;
			default:
				return 0;
		}
	}
	
	function canSave() {
		// check if all the grades under the limit
		if (!props.techMap || !props.techMap.activities)
			return true;

		const sumByGradeType = [];
		console.log('canSave.student', student);
		console.log('lesson.grades', lesson);
		// Здесь проверка идет по одному Lesson, а должно быть по всем в рамках студента. 
		// Есть вероятность, что эта проверка нам не нужна в целом, так как есть server-side валидация
		
		function processGrade(grade) {
			if (grade.gradeType > 0) {
				let gradeTypExistingItem = sumByGradeType.find((item) => item.gradeType === grade.gradeType);
				if (!gradeTypExistingItem) {
					gradeTypExistingItem = {
						gradeType: grade.gradeType,
						sum: 0
					};

					sumByGradeType.push(gradeTypExistingItem);
				}
				
				const gradeActivity = props.techMap.activities.find((a) => a.disciplineRequirementId === grade.gradeType);

				gradeTypExistingItem.sum += // grade.grade * 
					(grade.gradeType > 0
					? regularGradeToDisciplineRequirementGrade(grade.grade, gradeActivity)
					: grade.grade);
			}
		}
		
		lesson.grades.forEach((grade) => {
			processGrade(grade);
		});
		student.lessons.forEach((l) => {
			l.grades.forEach((grade) => {
				if (lesson.lessonId !== l.lessonId) {
					processGrade(grade);
				}
			});
		});

		let correct = true;
		if (!isAdmin) {
			props.techMap.activities.forEach((gradeType) => {
				if (sumByGradeType.find((item) => item.gradeType === gradeType.disciplineRequirementId)?.sum > gradeType.maxPoints && correct) {
					correct = false;
					console.warn(`Превышен лимит баллов по типу оценки "${gradeType.gradeTypeTitle}"`, sumByGradeType);
					console.log('Сумма баллов по типу оценки', sumByGradeType.find((item) => item.gradeType === gradeType.disciplineRequirementId)?.sum);
					alert(`Превышен лимит баллов по типу оценки "${gradeType.gradeTypeTitle}"`);
				}
			});
		}

		return correct;
	}

	const saveStudent = () => {
		if (!canSave())
			return;
		
		const newStudent = { ...student };
		setStudent(newStudent);
		props.saveHandler(student, lesson);
	};

	const handleValue = (e, gradeItem) => {
		const currentVal = numbersOnly(e.target.value); 
		// gradeItem.grade = gradeItem < 0 || isEmptyGradeType(gradeItem.gradeType)
		// 	? currentVal
		// 	: (gradeToPoints(currentVal, findGradeType(gradeItem.gradeType)));
		gradeItem.grade = parseFloat(currentVal);
		console.log('set new grade',gradeItem.grade)
		applyVisualChanges();
	};

	function numbersOnly(input) {
		if (!input)
			return '';

		const allowedSymbols = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '.'];
		let result = '';
		input.split('').forEach((symbol, index) => {
			if (allowedSymbols.includes(symbol)) {
				result += symbol;
				// if (symbol === ',' || symbol === '.' && input.length === index + 1) {
				//     result += '0';
				// }
			}
		});

		result = result.replace(',', '.');

		return result;
	}

	const removeVal = (value, index) => {
		// const newStudent = { ...student };
		// const newVals = lesson.grades;
		value.deleted = true;
		// lesson.grades.splice(lesson.grades.indexOf(value), 1);
		// newVals.splice(newVals.indexOf(value), 1);
		// setStudent(newStudent);
		
		applyVisualChanges();
	};
	
	function applyVisualChanges() {
		setRefresh(!refresh);
	}

	const addValue = () => {
		if (disabled) {
			alert('Редактирование недоступно');
			return;
		}
		
		const newStudent = { ...student };
		const newVal = {
			grade: 5,
			gradeType: 0,
			lessonStudentDetailsId: lesson.lessonStudentDetailsId,
			lessonStudentGradeId: 0
		};
		
		if (lesson.grades.length <= 3) {
			lesson.grades.push(newVal);
			setStudent(newStudent);
		}
	};

	const date = (type) => {
		if (student) {
			if (lesson !== null) {
				if (type === "date") {
					const stringDate = dayjs(lesson.lessonDate);
					return stringDate.format("D MMMM YYYY г.");
				}

				if (type === "class") return '';

				if (type === "values") 
					return lesson.grades;
			}
		}

		return "";
	};

	const handleValueType = (newVal, event) => {
		const newStudent = { ...student };
		const valIndex = event.props["data-val"];
		lesson.grades[valIndex].gradeType = newVal.target.value;
		setStudent(newStudent);
	};
	
	function findGradeType(gradeType) {
		const res = techMap?.activities?.find((item) => item.disciplineRequirementId === gradeType);
		return res;
	}
	
	function isEmptyGradeType(gradeType) {
		const item = findGradeType(gradeType);
		if (!item)
			return false;
		
		return !item.conversionGrade5 && !item.conversionGrade4 && !item.conversionGrade3 && !item.conversionGrade2;
	}
	
	function gradeToPoints(grade, gradeType) {
		grade = parseInt(grade.toString(), 10);
		console.log('gradeToPoints', grade, gradeType);
		const item = findGradeType(gradeType.disciplineRequirementId);
		console.log('Item', item);
		const newGrade = grade === 5
			? item.conversionGrade5
			: grade === 4
				? item.conversionGrade4
				: grade === 3
					? item.conversionGrade3
					: grade === 2
						? item.conversionGrade2
						: 0;
		
		console.log('newgrade', newGrade);
		return newGrade;
	}

	function pointsToGrade(points, gradeType) {
		console.log('pointsToGrade', points, gradeType);
		const item = findGradeType(gradeType);
		console.log('pointsToGrade item =', item);
		if (!item)
			return 0;
		
		return points === item.conversionGrade5
			? 5
			: points === item.conversionGrade4
				? 4
				: points === item.conversionGrade3
					? 3
					: points === item.conversionGrade2
						? 2
						: 0;
	}

	const values = () => {
		const vals = date("values");

		if (typeof vals === "object" && vals) {
			return vals.filter((item) => item.deleted === undefined || item.deleted === false || item.deleted === null)
				.map((value, index) => (
				<div className="value-wrapper" key={index}>
					<div className="value-type" data-val={index}>
						<Select
							onChange={handleValueType}
							disabled={disabled}
							label="Тип оценки"
							variant="standard"
							value={value.gradeType}
							sx={{ width: "100%" }}
						>
							{techMap?.activities?.map((item) => {
								return <MenuItem data-val={index} value={item.disciplineRequirementId}>
									{item.gradeTypeTitle}
								</MenuItem>
							})}
							<MenuItem
								disabled={techMap?.activities?.length > 0}
								data-val={index} 
							    value={-1}>
								Тестирование
							</MenuItem>
							<MenuItem
								disabled={techMap?.activities?.length > 0}
								data-val={index}
								value={-2}
							>
								Лабораторная работа
							</MenuItem>
							<MenuItem
								disabled={techMap?.activities?.length > 0}
								data-val={index}
								value={-3}
							>
								Контрольная работа
							</MenuItem>
							<MenuItem
								disabled={techMap?.activities?.length > 0}
								data-val={index}
								value={-4}
							>
								Расчётно-графическая работа
							</MenuItem>
							<MenuItem
								disabled={techMap?.activities?.length > 0}
								data-val={index} 
								value={-5}>
								Домашняя работа
							</MenuItem>
							<MenuItem
								disabled={techMap?.activities?.length > 0}
								data-val={index} 
							    value={-6}>
								Другое
							</MenuItem>
						</Select>
					</div>
					<div className="value">
						<ThemeProvider theme={toggleTheme}>
							{techMap?.activities
							&& isEmptyGradeType(value.gradeType)
							? <TextField size={'small'}
										 value={value.grade > findGradeType(value.gradeType)?.points ?? 0 ? 0 : value.grade}
										 onChange={(event) => handleValue(event, value)}
										 label={`Баллы (${findGradeType(value.gradeType)?.points ?? 0} макс.)`} />
							: <ToggleButtonGroup
									sx={{ width: "100%" }}
									exclusive
									disabled={disabled}
									value={ /* value.gradeType > 0 ? pointsToGrade(parseFloat(value.grade.toString()), value.gradeType) : */ value.grade}
									onChange={(event) => {handleValue(event, value)}}
								>
									<ToggleButton
										size="small"
										value={5}
										data-value={index}
										sx={{ flexGrow: 1 }}
									>
										5
									</ToggleButton>
									<ToggleButton
										size="small"
										value={4}
										data-value={index}
										sx={{ flexGrow: 1 }}
									>
										4
									</ToggleButton>
									<ToggleButton
										size="small"
										value={3}
										data-value={index}
										sx={{ flexGrow: 1 }}
									>
										3
									</ToggleButton>
									<ToggleButton
										size="small"
										value={2}
										data-value={index}
										sx={{ flexGrow: 1 }}
									>
										Неуд
									</ToggleButton>
								</ToggleButtonGroup>}
						</ThemeProvider>

						{/* {value.gradeType > 0 */}
						{/*	? <Typography fontSize={'small'}>Баллы БРС: {value.grade}</Typography> */}
						{/*	: <></>} */}
					</div>
					<div className="value-actions">
						<Button
							variant="text"
							disabled={disabled}
							sx={{ color: "red" }}
							data-value={index}
							onClick={() => removeVal(value)}
						>
							Удалить
						</Button>
						<Button
							variant="text"
							disabled={
								lesson.grades.length >= 3 || disabled
							}
							onClick={addValue}
						>
							Добавить
						</Button>
					</div>
				</div>
			));
		}
		
		return <></>
	};

	const studentAbsent = (s) => {
		// const day = s.days[lesson];
		//
		// if (
		// 	(day.absent_reason === "" || day.absent_reason === null) &&
		// 	(day.absent_doc === "" || day.absent_doc === null) &&
		// 	(day.absent_link === "" || day.absent_link === null)
		// ) {
		// 	return "absent";
		// }
		//
		// return "soft-absent";
		return '';
	};

	const handleFile = (e, newVal) => {
		const file = e.target.files[0];
		const newStudent = { ...student };
		const day = newStudent.days[lesson];
		day.class = studentAbsent(newStudent);
		day.absent_link = file ? file.name : "Выберите файл";
		newStudent.days[lesson] = day;
		setStudent(newStudent);
	};

	const clearFile = () => {
		const newStudent = { ...student };
		const day = newStudent.days[lesson];
		day.class = studentAbsent(newStudent);
		day.absent_link = "";
		newStudent.days[lesson] = day;

		setStudent(newStudent);
	};

	const inputLabel = () => {
		const clearFileClass =
			student.days[lesson].absent_link === null ||
			student.days[lesson].absent_link === ""
				? "clear-file hide"
				: "clear-file";
		return (
			<label htmlFor="reason_file" className="file-wrapper">
				<div className="file-label">
					<AttachmentRounded />
					<span>
						{student.days[lesson].absent_link || "Выберите файл"}
					</span>
				</div>
				<div className="clear-wrapper">
					<IconButton onClick={clearFile} className={clearFileClass}>
						<DeleteRounded />
					</IconButton>
				</div>
			</label>
		);
	};

	const commentChange = (e) => {
		lesson.comment = e.target.value;
		applyVisualChanges()
	};

	const docnameChange = (e) => {
		const newStudent = { ...student };
		const day = newStudent.days[lesson];
		day.absent_doc = e.target.value;
		day.class = studentAbsent(newStudent);
		newStudent.days[lesson] = day;
		setStudent(newStudent);
	};

	const clearValues = () => {
		const newStudent = { ...student };
		newStudent.days[lesson].values = [];
		setStudent(newStudent);
	};

	const reason = () => {
		return (
			<div>
				<div className="reason-block">
					<TextField
						sx={{ width: "100%" }}
						onChange={commentChange}
						multiline
						variant="standard"
						value={lesson?.comment ?? ''}
						label="Комментарий"
					/>
				</div>
			</div>
		);
	};

	return (
		<div
			className={props.open ? "modal-wrapper open" : "modal-wrapper"}
			id="value-modal"
		>
			<div className="modal">
				<div className="modal-content">
					<div className="modal-header" style={{'display': 'flex', 'justifyContent': 'space-between'}}>
						<div className="name">
							{student?.lastName} {student?.firstName} {student?.middleName}
						</div>
						<IconButton onClick={closeModal}>
							<CloseRounded />
						</IconButton>
					</div>

					{isAdmin ? <><Chip label={`Режим администратора - идентификатор ${lesson?.lessonStudentDetailsId}`} size="small" /><br /><br /></> : <></>}
					<KVPair _key="Дата" _value={date("date")} />
					<KVPair
						_key="Присутствие"
						_value={
							<StyledSwitch
								disabled={disabled}
								checked={lesson?.attended}
								onChange={setPresenceState}
							/>
						}
					/>
					{addEmptyButton()}
					{values()}
					{reason()}
				</div>
				<div className="modal-footer" style={{'display': 'flex', 'justifyContent': 'end'}}>
					<Button variant="text" onClick={saveStudent}>
						Сохранить
					</Button>
				</div>
			</div>
		</div>
	);
}

export default ValueModal;
